import React from 'react';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

import { useSharingTools } from '../../../../hooks/useSharingTools';
import type { Platform } from '../../../../shared/constants';
import { SharingToolsCardWrapperVariant1 } from '../../../SharingToolsCardWrapper';
import { SocialContentPreview } from '../SocialContentPreview';

/**
 * Wrapper for SocialContentPreview in a card.
 * Displays a loading skeleton with shimmer effect while post content is being fetched,
 * and renders the actual content when shareVisual is provided.
 */
export const SocialContentPreviewLoadingVariant1: React.FC<Props> = ({
	platform = 'instagram',
	title = translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.social_content.title'),
	description = translationKey(
		'corgi.petition.starter_dashboard_v2.sharing_tools.social_content.description_variation_1',
	),
}) => {
	const { data, actions } = useSharingTools('petition_dashboard_grow_petition_v1');

	return (
		<SharingToolsCardWrapperVariant1
			title={title}
			description={description}
			primaryActionOnClick={actions.navigateToShareVisual}
		>
			<SocialContentPreview
				isLoading={data.shareVisual.isLoading}
				shareVisual={data.shareVisual.image}
				platform={platform}
			/>
		</SharingToolsCardWrapperVariant1>
	);
};

type Props = Readonly<{
	shareVisual?: {
		url: string;
		variationName: string;
	};
	platform?: Platform;
	title?: TranslationKey;
	description?: TranslationKey;
}>;
